"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoPopUpContent = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.InfoPopUpContent = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 50px;
  max-width: 600px;

  h1 {
    color: #7b4ef8;
    text-align: center;
  }
`;
